import { APIService } from '../api';
import { AuthService } from '../auth';
import { upperFirst } from '../utils/strings/upperFirst';
import { Customer } from './Customer';
import { Image } from './Image';
import { Model } from './Model';
import { HasMany, HasOne, Relations, Relationship } from './Relations';
import { Role, Roles } from './Role';

export class User extends Model implements Relations<User> {
    public readonly blueprint = User;
    public readonly endpoint = APIService.createEndpoint('users');
    public email!: string;
    public phone!: string;
    public first_name!: string;
    public last_name!: string;
    public full_name!: string;
    public thumbnail!: string;
    public verified: boolean;
    public customer_id: number;
    public factory_id: number;
    public language_code: string;
    public user_view: string;
    public customer: Customer;
    public image!: Image;
    public roles: Role[];

    public static async LoginAs(userId: number) {
        await AuthService.getInstance().loginAs(userId);
    }

    public relations(): Relationship<{ new (): User }>[] {
        return [HasOne('image', Image, User), HasMany('roles', Role, User), HasMany('customer', Customer, User)];
    }

    public $fullName() {
        if (this.full_name) {
            return this.full_name;
        }

        return `${upperFirst(this.first_name ?? '')} ${upperFirst(this.last_name ?? '')}`.trim();
    }

    public $thumbnail() {
        if (this.thumbnail) {
            return this.thumbnail;
        } else if (this.image) {
            return this.image.thumbnail_path ?? this.image.file_path;
        }

        return null;
    }

    hasRole(role: Roles) {
        return !!this.roles.find(({ id, name }) => id === role || name === role);
    }
}
